import React from 'react';

const AdminCategories = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Categories Management</h1>
      <p>Manage your categories here</p>
    </div>
  );
};

export default AdminCategories;